// actions.js
export const updateUserData = (userData) => ({
  type: "UPDATE_USER_DATA",
  payload: userData,
});
